// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__bNzfR","green":"style_green__0lHD7","dissabledSt":"style_dissabledSt__ZXkRb","black":"style_black__pKHJ-","transparent":"style_transparent__5pWFE"};